import { useSmoothScroll } from '@uds/smooth-scroll';
import { jsx } from 'react/jsx-runtime';

const Link = _ref => {
  let {
    href,
    onClick,
    scrollToRef,
    ...props
  } = _ref;
  const smoothScroll = useSmoothScroll();
  const handleOnClick = e => {
    if (onClick) {
      onClick(e);
    }
    if (scrollToRef != null) {
      smoothScroll(scrollToRef);
    }
  };
  const LinkTag = href != null ? 'a' : 'button';
  return /*#__PURE__*/jsx(LinkTag, {
    ...props,
    href: href,
    onClick: handleOnClick,
    children: props.children
  });
};
Link.displayName = 'Link';
var Link$1 = Link;

export { Link$1 as default };
